import { Effect } from "@/modules/effects/domain/Effect";
import { PendingEffectListScreenData } from "@/modules/effects/domain/PendingEffectListScreenData";

export class VuePendingEffectListScreenData implements PendingEffectListScreenData{
    effects: Effect[];
    loading: boolean;
    effectsHeaders: Object
    selectedEffects: Effect[]
    showSelectEffects: boolean
    limit:number
    tableHeight:string

    constructor(){
        this.effects = []
        this.loading = false
        this.effectsHeaders = [            
            {
              text: 'Fecha',
              sortable: false,
              value: 'date'
            },
            {
              text: 'Importe',
              sortable: false,
              value: 'amount'
            },           
            {
              text: 'Importe no punteado',
              sortable: false,
              value: 'amount_no_punteado'
            },  
            {
              text: 'Cuenta',
              sortable: false,
              value: 'account'
            },           
            {
              text: 'Concepto',
              sortable: false,
              value: 'concept'
            },        
            {
              text: 'Tipo de efecto',
              sortable: false,
              value: 'effect_type'
            },
            {
              text: 'Num. Factura',
              sortable: false,
              value: 'invoice_number'
            },
            {
              text: 'Estado',
              sortable: false,
              value: 'state',
              width:1,
            },   
            {
              text: 'Origen',
              sortable: false,
              value: 'origin'
            }, 
          ]  
          this.selectedEffects = []
          this.showSelectEffects = false
          this.limit = 10
          this.tableHeight = "470px"
    }

    setLoading(loading: boolean){
        this.loading = loading;
    }

    setEffects(effects_data: Effect[]){
        this.effects = effects_data;
    }
    
    setShowSelectEffects(showSelectEffects: boolean){
        this.showSelectEffects = showSelectEffects;
    }

    setTableHeight(table_height:string){
      this.tableHeight = table_height;
    }
    setLimit(value:number){
      this.limit = value;
    }

    resetSelectedEffects() {
      this.selectedEffects = []
    }
}